import styled from "styled-components";
import bg from "assets/images/Elle_Tiffany_2021_04_210858.jpg";
import { fonts } from "styles";

export const Container = styled.section`
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  display: flex;

  @media screen and (max-width: 1024px) {
    flex-direction: column-reverse;
    height: 100%;
  }
`;

export const Content = styled.div`
  width: 50%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &.mobile {
    display: none;
  }

  &.left {
    background: #ccc url(${bg}) no-repeat center top;
    background-size: cover;
  }

  &.right {
    background-color: white;
    padding: 96px;
  }

  @media screen and (max-width: 1024px) {
    width: 100%;
    height: 100%;

    &:left {
      display: none;
    }

    &.mobile {
      padding: 0 96px;
      display: flex;
    }
  }

  @media screen and (max-width: 580px) {
    &.right {
      padding: 102px 32px 48px 32px;
    }
    &.mobile {
      padding: 0 32px;
    }
  }
`;

export const ImageGirl = styled.img.attrs({ src: bg })`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const Title = styled.h1`
  font-size: 45px;
  line-height: 45px;
  text-align: center;
  margin-bottom: 70px;

  @media screen and (max-width: 1680px) {
    font-size: 38px;
    line-height: 38px;
  }

  @media screen and (max-width: 1440px) {
    font-size: 32px;
    line-height: 32px;
  }

  @media screen and (max-width: 1024px) {
    max-width: 550px;
  }

  @media screen and (max-width: 414px) {
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 48px;
  }

  @media screen and (max-width: 320px) {
    font-size: 18px;
    line-height: 18px;
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 580px;
  font-family: ${fonts.BentonSansWide};
  font-size: 35px;
  line-height: 45px;
  text-align: center;

  @media screen and (max-width: 1680px) {
    font-size: 28px;
    line-height: 38px;
    max-width: 550px;
  }

  @media screen and (max-width: 1440px) {
    font-size: 24px;
    line-height: 34px;
  }

  @media screen and (max-width: 414px) {
    font-size: 18px;
    line-height: 28px;
  }

  @media screen and (max-width: 320px) {
    font-size: 14px;
    line-height: 24px;
  }
`;
